<template>
    <b-nav type="light" class="mt-2 ml-2">
        <b-nav-item
            @focus="onFocus(xi18n(i8nPrefix, 'map'))"
            :to="{ name: 'accessibleInfo' }"
            class="mr-4 accessible-link"
            >{{ xi18n(i8nPrefix, 'map') }}
        </b-nav-item>
        <b-nav-item
            @focus="onFocus(xi18n(i8nPrefix, 'selection'))"
            :to="{ name: 'accessibleData' }"
            class="mr-4 accessible-link"
            :disabled="!dataEnabled"
            >{{ xi18n(i8nPrefix, 'selection') }}
        </b-nav-item>
        <b-nav-item
            @focus="onFocus(xi18n(i8nPrefix, 'search'))"
            :to="{ name: 'accessibleSearch' }"
            class="mr-4 accessible-link"
            >{{ xi18n(i8nPrefix, 'search') }}
        </b-nav-item>
        <b-nav-item
            @focus="onFocus(xi18n(i8nPrefix, 'options'))"
            :to="{ name: 'accessibleOptions' }"
            class="mr-4 accessible-link"
            >{{ xi18n(i8nPrefix, 'options') }}
        </b-nav-item>
        <b-nav-item
            @focus="onFocus(xi18n(i8nPrefix, 'close'))"
            @click="onClose"
            class="mr-4 accessible-link"
            >{{ xi18n(i8nPrefix, 'close') }}
        </b-nav-item>
    </b-nav>
</template>

<script>
    import { mapState, mapActions, mapGetters } from 'vuex';
    import { INTERFACE_PANEL_TRIGGERS } from '../../../../constants';

    export default {
        name: 'mobile-nav-bar',
        data() {
            return {
                searchResultsPanelName: INTERFACE_PANEL_TRIGGERS.SEARCH_RESULTS,
                filtersPanelName: INTERFACE_PANEL_TRIGGERS.FILTERS,
                i8nPrefix: 'accessibility'
            };
        },
        computed: {
            ...mapState(['uiElements']),
            ...mapGetters(['getWebTheme', 'getWebThemeParameters']),
            menuComponents: function () {
                return this.uiElements.menuBar.components;
            },
            showSearch() {
                return this.getWebTheme?.data?.showSearch;
            },
            showFullScreen() {
                return this.getWebTheme?.data?.showFullScreen;
            },
            dataEnabled() {
                return this.$store.state.selections?.[0]?.results?.length > 0;
            }
        },
        methods: {
            ...mapActions(['togglePanel']),

            onFocus(text) {
                this.$store.dispatch('say', { text });
            },
            onClose() {
                this.$router.push({
                    name: 'WebMap',
                    query: {
                        tma:
                            this.getWebThemeParameters.guid ||
                            this.getWebThemeParameters.tma
                    }
                });
            }
        }
    };
</script>

<style scoped lang="scss">
.accessible-link .nav-link {
    color: black;
    font-size: 1.4em;
    text-transform: capitalize;
    &.is-active {
        text-decoration: underline;
    }
    &.disabled {
        text-decoration: line-through;
    }
}
</style>
